import { Pipe, PipeTransform } from '@angular/core';
import {
  FONT_HTML_EDITOR_ITEMS,
  FONT_STYLE_HTML_EDITOR_ITEMS,
  HEADER_STYLE_HTML_EDITOR_ITEMS,
  HTML_EDITOR_ITEMS,
  HtmlEditorTypeKeys,
  IMAGE_STYLE_HTML_EDITOR_ITEMS,
  LINK_STYLE_HTML_EDITOR_ITEMS,
  LIST_STYLE_HTML_EDITOR_ITEMS,
  PARAGRAPH_STYLE_HTML_EDITOR_ITEMS,
  TEXT_DECORATION_HTML_EDITOR_ITEMS,
  VARIABLE_STYLE_HTML_EDITOR_ITEMS,
} from '@ag-common-lib/public-api';

@Pipe({
  name: 'htmlEditorToolbarItems',
})
export class HtmlEditorToolbarItemsPipe implements PipeTransform {
  constructor() {}
  transform(types?: HtmlEditorTypeKeys[], container?: string | Element) {
    return this.generateToolbarItems(types);
  }

  private generateToolbarItems = types => {
    const itemTypes = types ?? [
      HtmlEditorTypeKeys.font,
      HtmlEditorTypeKeys.fontStyle,
      HtmlEditorTypeKeys.paragraph,
      HtmlEditorTypeKeys.header,
      HtmlEditorTypeKeys.link,
      HtmlEditorTypeKeys.image,
    ];
    const editorItems = [];

    itemTypes.forEach(type => {
      switch (type) {
        case HtmlEditorTypeKeys.font:
          editorItems.push(...FONT_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.fontStyle:
          editorItems.push(...FONT_STYLE_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.paragraph:
          editorItems.push(...PARAGRAPH_STYLE_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.list:
          editorItems.push(...LIST_STYLE_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.header:
          editorItems.push(...HEADER_STYLE_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.link:
          editorItems.push(...LINK_STYLE_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.variable:
          editorItems.push(...VARIABLE_STYLE_HTML_EDITOR_ITEMS);
          break;

        case HtmlEditorTypeKeys.image:
          editorItems.push(...IMAGE_STYLE_HTML_EDITOR_ITEMS);
          break;

        // case HtmlEditorTypeKeys.preview:
        //   const PREVIEW_HTML_EDITOR_ITEMS = { widget: 'dxButton', options: this.toolbarButtonOptions, name: 'eyeopen' };
        //   editorItems.push(PREVIEW_HTML_EDITOR_ITEMS);
        //   break;

        case HtmlEditorTypeKeys.textDecoration:
          editorItems.push(...TEXT_DECORATION_HTML_EDITOR_ITEMS);
          break;

        default:
          editorItems.push(...HTML_EDITOR_ITEMS);
          break;
      }
    });

    return editorItems;
  };
}
